module.exports = __webpack_public_path__ + "static/media/sustainability-icon.ca9652f6.svg";